import isFn from '@utils/is-function';
import AddPayment from '../add-payment';
import template from './templates/checkout-payment-form';
import { context as defaultContext } from './checkout-defaults';
import { url as apiUrl } from '@api/routes/account/addpaymentmethod';

/**
 * @typedef {Object} DefaultOptions
 * @property {Function?} onCancelHandler
 * @property {boolean} replaceOriginEl
 */

/** @type {DefaultOptions} */
const DEFAULT_OPTIONS = {
    classList: '',
    onCancelHandler: null,
    setupMethods: null,
    replaceOriginEl: false
};

export default class CheckoutPaymentForm {
    constructor($originEl, context, options) {
        context = { ...defaultContext, ...context };
        options = { ...DEFAULT_OPTIONS, ...options };

        const $parsed = $($.parseHTML(template));
        this.$el = $parsed;
        this.$originEl = $originEl;

        this.$cancelLabel = this.$el.find('[data-label="cancel"]');
        this.$headingLabel = this.$el.find('[data-label="heading"]');
        this.$subscriptionsLabel = this.$el.find('[data-label="subscriptions"]');
        this.$submitLabel = this.$el.find('[data-label="submit"]');

        this.$amex = this.$el.find('[data-region="amex"]');
        this.$ccList = this.$el.find('[data-region="ccList"]');
        this.$discover = this.$el.find('[data-region="discover"]');
        this.$mastercard = this.$el.find('[data-region="mastercard"]');
        this.$visa = this.$el.find('[data-region="visa"]');

        this.$cancel = this.$el.find('[data-control="cancel"]');

        this.form = null;

        this.classList = options.classList;
        this.onCancelHandler = isFn(options.onCancelHandler) || null;
        this.setupMethods = isFn(options.setupMethods) || null;
        this.replaceOriginEl = options.replaceOriginEl;

        this.context = context;

        this.init();
    }

    init() {
        this.renderLabels();
        this.renderAcceptedCards();
        this.setupCancel();
        this.setupClassList();
    }

    render() {
        if(this.$originEl) {
            if(this.replaceOriginEl) {
                this.$originEl.replaceWith(this.$el);
            } else {
                this.$originEl.html(this.$el);
            }
        }

        this.setupBlufin();

        return this.$el;
    }

    renderAcceptedCards() {
        const {
            AmexIcon: amex,
            DiscoverIcon: discover,
            MastercardIcon: mastercard,
            VisaIcon: visa
        } = this.context;

        if(!amex.Url && !discover.Url && !mastercard.Url && !visa.Url) {
            this.$ccList.hide();
            return;
        }

        const img = document.createElement('img');

        [
            [ this.$amex, amex ],
            [ this.$discover, discover ],
            [ this.$mastercard, mastercard ],
            [ this.$visa, visa ]
        ].forEach(([ $el, card ]) => {
            if(card.Url) {
                const icon = img.cloneNode(false);
                icon.alt = card.Alt;
                icon.src = card.Url;
                $el.html(icon);
            } else {
                $el.hide();
            }
        });
    }

    renderLabels() {
        this.$cancelLabel.html(this.context.Cancel);
        this.$headingLabel.html(this.context.AddPaymentMethod);
        this.$subscriptionsLabel.html(this.context.ActiveSubscriptions);
        this.$submitLabel.html(this.context.SavePayment);
    }

    setAddressId(addressId) {
        this.form.options.addressId = addressId;
    }

    setupBlufin() {
        //console.log('form 2', this)
        this.form = new AddPayment({
            containerId: '#addPaymentContainer',
            paymentFrameContainerId: 'paymentFrameContainer',
            paymentLoaderId: '#paymentLoader',
            savePaymentId: '#savePayment',
            savePaymentErrorId: '#addPaymentFailure',
            settingsId: '#paymentSettings',
            setupMethods: this.setupMethods,
            updateAutoshipCheckboxId: '#active-subscriptions',
            urlPath: apiUrl
        });
        //console.log('form 2', this.form)
        window.form = this.form;
    }

    setupCancel() {
        if(this.onCancelHandler) {
            this.$cancel.on('click', () => this.onCancelHandler());
        } else {
            this.$cancel.hide();
        }
    }

    setupClassList() {
        this.$el.addClass(this.classList);
    }
}
